module.exports = __webpack_public_path__ + "img/modalRecapSvg2024-pt.222fda59.svg";